import { render, staticRenderFns } from "./roomOweFees.vue?vue&type=template&id=32189d4c&scoped=true"
import script from "./roomOweFees.vue?vue&type=script&lang=js"
export * from "./roomOweFees.vue?vue&type=script&lang=js"
import style0 from "./roomOweFees.vue?vue&type=style&index=0&id=32189d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32189d4c",
  null
  
)

export default component.exports